import Vue from 'vue';
import VueI18n from 'vue-i18n';
import zh from './zh';
import en from './en';

// 安装VueI18n插件
Vue.use(VueI18n);

// 创建i18n实例
const i18n = new VueI18n({
  // 从localStorage获取语言设置，默认使用中文
  locale: localStorage.getItem('language') || 'zh',
  // 启用全局注入，可在模板中直接使用$t而无需this
  globalInjection: true,
  // 关闭警告
  legacy: false,
  // 禁止在控制台输出警告
  silentFallbackWarn: true,
  // 关闭生产环境下的警告
  // silentTranslationWarn: process.env.NODE_ENV === 'production',
  // 语言包对象
  messages: {
    zh,
    en
  }
});

export default i18n;